import { useCallback } from 'react';
import type { SubmitHandler } from 'react-hook-form';

import { useMessages } from '../../../contexts/MessagesContext';
import type { NewTicketMessageFormValuesT } from '../declarations';

type UseMessageFormT = {
  handleSubmitForm: SubmitHandler<NewTicketMessageFormValuesT>;
};

const useMessageForm = (assignToWarrCloud: boolean): UseMessageFormT => {
  /**
   * Hooks
   */
  const { handleCreateUnsavedMessage } = useMessages();

  /**
   * Handlers
   */
  const handleSubmitForm = useCallback(
    (data: NewTicketMessageFormValuesT) => {
      handleCreateUnsavedMessage(data, assignToWarrCloud);
    },
    [handleCreateUnsavedMessage, assignToWarrCloud]
  );

  return {
    handleSubmitForm,
  };
};

export default useMessageForm;
